// extracted by mini-css-extract-plugin
export default {"root":"UserProfile_root__0tJPx"};